import { asHintAnchorId } from '@/shared/stores';

/**
 * Hint-anchor IDs.
 *
 * Anchors live at the `app/` layer so every hint concern (anchor identity,
 * copy, registration) sits in one place. Features import these constants
 * and pass them to `useHintAnchor` to bind a DOM element; they never
 * invent or own anchor strings themselves.
 */

export const CARE_STATE_FIRST_OPEN_REQUEST_ANCHOR = asHintAnchorId('care-state:first-open-request');
export const CARE_STATE_NOTE_TAB_ANCHOR = asHintAnchorId('care-state-note:tab');
export const PROPOSED_ACTIONS_FIRST_ACTION_ANCHOR = asHintAnchorId('proposed-actions:first-action');
export const PATIENT_PANEL_TABS_ANCHOR = asHintAnchorId('patient-panel:tabs');
export const PATIENT_SNAPSHOT_TAB_ANCHOR = asHintAnchorId('patient-snapshot:tab');
export const PATIENT_CHAT_HISTORY_ANCHOR = asHintAnchorId('patient-chat:history');
export const COPILOT_COMPOSER_ANCHOR = asHintAnchorId('copilot:composer');
export const COPILOT_ORDERS_CHIP_ANCHOR = asHintAnchorId('copilot:orders-chip');

// Dashboard onboarding sequence — fires on first dashboard visit. Each anchor
// binds to an existing dashboard element; per-card anchors are bound only to
// the first patient queue card so they always resolve to a known target.
export const DASHBOARD_URGENT_TAB_ANCHOR = asHintAnchorId('dashboard:urgent-tab');
export const DASHBOARD_ROUTINE_TAB_ANCHOR = asHintAnchorId('dashboard:routine-tab');
export const DASHBOARD_KARMA_PILL_ANCHOR = asHintAnchorId('dashboard:karma-pill');
export const DASHBOARD_PATIENT_RELATIONSHIP_ANCHOR = asHintAnchorId(
  'dashboard:patient-relationship'
);
export const DASHBOARD_PATIENT_VIEWER_ANCHOR = asHintAnchorId('dashboard:patient-viewer');
export const DASHBOARD_PATIENT_LOCATION_ANCHOR = asHintAnchorId('dashboard:patient-location');
export const DASHBOARD_PATIENT_REQUESTS_ANCHOR = asHintAnchorId('dashboard:patient-requests');
